'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Constant = require('./Constant');

var _SmartSuggestResult = require('./SmartSuggestResult');

var _SmartSuggestResult2 = _interopRequireDefault(_SmartSuggestResult);

var _NearbySuburbResult = require('./NearbySuburbResult');

var _NearbySuburbResult2 = _interopRequireDefault(_NearbySuburbResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocationSearchBox = function (_React$Component) {
  _inherits(LocationSearchBox, _React$Component);

  function LocationSearchBox(props) {
    _classCallCheck(this, LocationSearchBox);

    var _this = _possibleConstructorReturn(this, (LocationSearchBox.__proto__ || Object.getPrototypeOf(LocationSearchBox)).call(this, props));

    _this.changeCurrentLocation = function (location) {
      _this.setState({
        myCurrentLocation: {
          locality: [location.coords.longitude, location.coords.latitude]
        }
      });
    };

    _this.isInMyLocation = function (location) {
      return _lodash2.default.includes(_this.state.myLocations.map(function (location) {
        return location.displayValue;
      }), location.displayValue);
    };

    _this.closePopup = function (event) {
      event && event.preventDefault();
      if (_this.locationInput.current) {
        _this.locationInput.current.blur();
      }
      if (_this.props.updateSearchWithinOption) {
        _this.props.updateSearchWithinOption(_this.locations.map(function (location) {
          return location.displayValue;
        }));
      }
      _this.setState({
        isPopped: false,
        smartSuggestResult: [],
        nearbySuburbResult: [],
        locationInputValue: ''
      });
    };

    _this.changeCursor = function (index) {
      if (_this.props.userAgent.isDesktop) {
        _this.setState({ locationCursor: index });
      }
    };

    _this.fetchSmartSuggestResult = _lodash2.default.throttle(function (locationInputValue, callback) {
      _this.setState({
        isLoading: true
      });

      _this.props.getSmartSuggestResult(locationInputValue).then(function (data) {
        _this.setState({
          isLoading: false
        });
        callback(data);
      });
    }, 500, { leading: true });
    _this.fetchNearbySuburbResult = _lodash2.default.throttle(function (locations, callback) {
      _this.setState({
        isLoading: true
      });

      _this.props.getNearbySuburbResult(locations).then(function (data) {
        _this.setState({
          isLoading: false
        });
        callback(data);
      });
    }, 500, { leading: true });


    _this.wrap = _react2.default.createRef();
    _this.locationInputBox = _react2.default.createRef();
    _this.locationInput = _react2.default.createRef();

    var myCurrentLocation = _this.props.currentLocation || [];
    var myLocations = _this.props.locations ? _lodash2.default.map(_this.props.locations, function (val) {
      return { displayValue: val };
    }) : [];

    _this.state = {
      isPopped: false,
      isLoading: false,
      locationInputValue: '',
      myLocations: myLocations,
      myCurrentLocation: {
        locality: myCurrentLocation
      },
      smartSuggestResult: [],
      nearbySuburbResult: [],
      locationCursor: _Constant.DefaultFreeTextIndex
    };
    return _this;
  }

  _createClass(LocationSearchBox, [{
    key: 'documentOnClickHandler',
    value: function documentOnClickHandler(event) {
      var _this2 = this;

      if (!this.wrap.current) {
        console.error('This should never happen, if it does React did not give us wrap ref');
        return;
      }
      var isSearchBoxClicked = this.wrap.current.contains(event.target);
      var isPopped = this.state.isPopped;


      if (isSearchBoxClicked) {
        this.setState({ isPopped: true }, function () {
          if (_this2.locationInput.current) {
            _this2.locationInput.current.focus();
          }
        });
        this.scrollToLocationSearchBox();
      } else if (!isSearchBoxClicked && isPopped) {
        this.closePopup();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.boundClickHandler = this.documentOnClickHandler.bind(this);
      if (document && document.addEventListener) {
        //  Add mouseup listener
        document.addEventListener('mouseup', this.boundClickHandler);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document && document.removeEventListener) {
        //  Remove mouseup listener
        document.removeEventListener('mouseup', this.boundClickHandler);
      }
    }
  }, {
    key: 'refreshPopup',
    value: function refreshPopup() {
      var _this3 = this;

      if (this.state.myLocations.length) {
        this.fetchNearbySuburbResult(_lodash2.default.map(this.state.myLocations, 'displayValue'), function (data) {
          var index = 0;
          if (data.length) {
            index = _lodash2.default.findIndex(data, function (item) {
              return !_this3.isInMyLocation(item);
            });
            _this3.setState({
              nearbySuburbResult: data,
              smartSuggestResult: [],
              locationInputValue: ''
            });
          } else {
            var freeTextLocation = { displayValue: _this3.state.locationInputValue };
            var activeItemIndex = _lodash2.default.findIndex(_this3.state.smartSuggestResult, function (item) {
              return !_this3.isInMyLocation(item);
            });
            index = _this3.isInMyLocation(freeTextLocation) ? activeItemIndex : _Constant.DefaultFreeTextIndex;
            _this3.changeCursor(index);

            _this3.setState({
              nearbySuburbResult: []
            });
          }
        });
      } else {
        this.setState({
          nearbySuburbResult: []
        });
        this.changeCursor(_Constant.DefaultFreeTextIndex);
      }
    }
  }, {
    key: 'switchToMyLocation',
    value: function switchToMyLocation(location) {
      if (_lodash2.default.isUndefined(location)) return;
      if (!('ontouchstart' in document) && this.locationInput.current) {
        this.locationInput.current.focus();
      }

      var callback = this.props.getNearbySuburbResult ? this.refreshPopup : null;
      if (location && this.isInMyLocation(location)) {
        this.setState({
          locationInputValue: '',
          myCurrentLocation: { locality: [] },
          myLocations: this.state.myLocations.filter(function (myLocation) {
            return myLocation.displayValue !== location.displayValue;
          })
        }, callback);
      } else {
        this.setState({
          locationInputValue: '',
          myCurrentLocation: { locality: [] },
          myLocations: this.state.myLocations.concat(location)
        }, callback);
      }
    }
  }, {
    key: 'moveLocationCursor',
    value: function moveLocationCursor(isToUp) {

      var locationCursor = this.state.locationCursor;
      var length = this.state.nearbySuburbResult.length || this.state.smartSuggestResult.length;

      if (length === 0) {
        this.setState({
          locationCursor: null
        });
      } else {
        if (isToUp) {
          // Up
          if (locationCursor == null || locationCursor === _Constant.DefaultFreeTextIndex) {
            this.setState({
              locationCursor: length - 1
            });
          } else {
            this.setState({
              locationCursor: locationCursor - 1
            });
          }
        } else {
          // Down
          if (locationCursor == null || locationCursor >= length - 1) {
            this.setState({
              locationCursor: _Constant.DefaultFreeTextIndex
            });
          } else {
            this.setState({
              locationCursor: locationCursor + 1
            });
          }
        }
      }
    }
  }, {
    key: 'renderClearAll',
    value: function renderClearAll() {
      var _this4 = this;

      if (this.state.myLocations.length) {
        return _react2.default.createElement('i', { className: 'icon delete clear-all', onClick: function onClick(event) {
            setTimeout(function () {
              _this4.setState({
                myLocations: [],
                nearbySuburbResult: [],
                smartSuggestResult: []
              });
            });
          } });
      }
    }
  }, {
    key: 'renderLocationInput',
    value: function renderLocationInput() {
      var _this5 = this;

      var inputValue = this.state.locationInputValue;

      var onKeyDownHandler = null;
      var placeholderText = 'Search by region, suburb or postcode';

      if (this.props.userAgent.isDesktop) {
        var freeTextLocation = { displayValue: this.state.locationInputValue };
        onKeyDownHandler = function onKeyDownHandler(event) {
          switch (event.keyCode) {
            case 38:
              //Up
              event.preventDefault();
              _this5.moveLocationCursor(true);
              break;
            case 40:
              //Down
              event.preventDefault();
              _this5.moveLocationCursor(false);
              break;
            case 13:
              //Enter
              event.preventDefault();
              _this5.switchToMyLocation(_this5.state.nearbySuburbResult[_this5.state.locationCursor] || _this5.state.smartSuggestResult[_this5.state.locationCursor] || freeTextLocation);
              break;
          }
        };
      } else {
        onKeyDownHandler = function onKeyDownHandler(event) {
          if (event.keyCode == 13) {
            event.preventDefault();
            _this5.closePopup(event);
          }
        };
      }

      if (this.props.userAgent.isMobile) {
        placeholderText = 'Search by suburb or postcode'; // mobile only
      }

      return _react2.default.createElement('input', {
        className: 'location-input-field',
        ref: this.locationInput,
        autoComplete: 'off',
        onKeyDown: onKeyDownHandler,
        value: inputValue,
        placeholder: placeholderText,
        type: 'text',
        onChange: function onChange(event) {
          var locationInputValueExcludeSpecialCharacters = event.target.value.replace(/[^A-Za-z0-9,\'\-\s]/g, '');

          _this5.setState({
            locationInputValue: locationInputValueExcludeSpecialCharacters
          });
          if (_lodash2.default.trim(locationInputValueExcludeSpecialCharacters).length > 2) {
            _this5.fetchSmartSuggestResult(locationInputValueExcludeSpecialCharacters, function (suggestionResult) {
              if (locationInputValueExcludeSpecialCharacters === _this5.state.locationInputValue) {
                if (suggestionResult && suggestionResult.length > 0) {
                  _this5.setState({
                    smartSuggestResult: suggestionResult.slice(0, 7),
                    nearbySuburbResult: []
                  });
                } else {
                  _this5.setState({
                    smartSuggestResult: [],
                    nearbySuburbResult: []
                  });
                }
              }
            });
          } else {
            _this5.setState({
              smartSuggestResult: [],
              nearbySuburbResult: []
            });
          }
        } });
    }
  }, {
    key: 'renderPopup',
    value: function renderPopup() {
      return _react2.default.createElement(
        'div',
        { className: 'location-popup' },
        this.state.myLocations.length > 0 && this.renderMyLocations(),
        this.state.nearbySuburbResult.length ? _react2.default.createElement(_NearbySuburbResult2.default, { nearbySuburbResult: this.state.nearbySuburbResult,
          isLoading: this.state.isLoading,
          switchToMyLocation: this.switchToMyLocation.bind(this),
          isInMyLocation: this.isInMyLocation,
          myLocations: this.state.myLocations,
          closePopup: this.closePopup,
          locationCursor: this.state.locationCursor,
          changeCursor: this.changeCursor,
          selectNearby: this.props.selectNearby
        }) : _react2.default.createElement(_SmartSuggestResult2.default, { smartSuggestResult: this.state.smartSuggestResult,
          isLoading: this.state.isLoading,
          locationInputValue: this.state.locationInputValue,
          switchToMyLocation: this.switchToMyLocation.bind(this),
          changeCurrentLocation: this.changeCurrentLocation,
          isInMyLocation: this.isInMyLocation,
          myLocations: this.state.myLocations,
          closePopup: this.closePopup,
          locationCursor: this.state.locationCursor,
          changeCursor: this.changeCursor,
          quickLinks: this.props.quickLinks,
          onClickQuickLink: this.props.onClickQuickLink
        })
      );
    }
  }, {
    key: 'renderMyLocations',
    value: function renderMyLocations() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        { className: 'my-location-box-wrap' },
        this.renderClearAll(),
        _react2.default.createElement(
          'ul',
          { className: 'my-location-box' },
          this.state.myLocations.map(function (location, index) {
            return _react2.default.createElement(
              'li',
              { key: index,
                className: 'my-location-item clearfix',
                onClick: function onClick(event) {
                  setTimeout(function () {
                    _this6.switchToMyLocation(location);
                  });
                } },
              _react2.default.createElement(
                'span',
                { className: 'my-location-text' },
                location.displayValue
              ),
              _react2.default.createElement('i', { className: 'remove-my-location icon cross' })
            );
          })
        )
      );
    }
  }, {
    key: 'renderMySearch',
    value: function renderMySearch() {
      var _this7 = this;

      var myLocations = this.state.myLocations;
      return _react2.default.createElement(
        'div',
        { className: 'my-hidden-search', onClick: function onClick() {
            _this7.scrollToLocationSearchBox();
          } },
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)('first-location', myLocations.length > 1 ? "margin-with-pill" : "") },
          this.state.myCurrentLocation.locality.length ? 'Current Location' : myLocations[0].displayValue
        ),
        myLocations.length > 1 && _react2.default.createElement(
          'span',
          { className: 'more' },
          _react2.default.createElement(
            'span',
            null,
            myLocations.length - 1,
            ' more'
          )
        )
      );
    }
  }, {
    key: 'scrollToLocationSearchBox',
    value: function scrollToLocationSearchBox() {
      if (this.props.userAgent.isMobile && !this.props.userAgent.isTablet && this.props.isScrollToViewTop) {
        if (this.locationInputBox.current) {
          this.locationInputBox.current.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('location-search-box-wrapper', this.state.isLoading && 'loading'), ref: this.wrap },
        _react2.default.createElement(
          'div',
          { className: 'location-input-box', ref: this.locationInputBox },
          _react2.default.createElement('i', { className: 'icon search' }),
          !this.state.isPopped && (this.state.myLocations.length > 0 || this.state.myCurrentLocation.locality.length > 0) ? this.renderMySearch() : this.renderLocationInput()
        ),
        this.state.isPopped && this.renderPopup()
      );
    }
  }, {
    key: 'getAtlasIds',
    get: function get() {
      return _lodash2.default.map(this.state.myLocations, 'atlasId');
    }
  }, {
    key: 'locations',
    get: function get() {
      return this.state.myLocations.concat();
    },
    set: function set(values) {
      return this.setState({
        myLocations: values.concat()
      });
    }
  }, {
    key: 'liveLocation',
    get: function get() {
      return this.state.locationInputValue;
    }
  }, {
    key: 'currentLocation',
    get: function get() {
      return this.state.myCurrentLocation.locality.concat();
    },
    set: function set(value) {
      return this.setState({
        myCurrentLocation: {
          locality: value
        }
      });
    }
  }]);

  return LocationSearchBox;
}(_react2.default.Component);

exports.default = LocationSearchBox;